import { fcAuth } from '@/api/group_master';
import { reportUploadImage } from '@/api';

const COS = require('cos-js-sdk-v5');
const TaskMap = new WeakMap()

let credentials = {};


var fcCos = new COS({
  // getAuthorization 必选参数
  getAuthorization: function (options, callback) {

    callback({
      TmpSecretId: credentials.tmpSecretId,
      TmpSecretKey: credentials.tmpSecretKey,
      SecurityToken: credentials.sessionToken,
      StartTime: credentials.startTime, // 时间戳，单位秒，如：1580000000
      ExpiredTime: credentials.expiredTime, // 时间戳，单位秒，如：1580000000
    });

  }
});

export function cancelTask(file) {
  if (TaskMap.has(file)) {
    // console.log('cancel', TaskMap.get(file))
    cos.cancelTask(TaskMap.get(file))
    TaskMap.delete(file)
  }
}

export function fcCodeUpload(params) {
  if (params.file.size > 1024 * 1024 * 2) {
    return params.onError(new Error("图片文件过大，请重新选择。"));
  }
  fcAuth().then(response => {
    try {
      var data = response.data;
      credentials = Object.assign({
        startTime: data.startTime,
        expiredTime: data.expiredTime,
      }, data.credentials);
    } catch (e) {
    }
    if (!data || !credentials) {
      return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
    };

    // console.log('uploadSeed', response)
    fcCos.uploadFile({
      ...data.extra,
      Body: params.file,
      SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onTaskReady: function (taskId) {                   /* 非必须 */
        console.log(taskId);
        TaskMap.set(params.file, taskId)
      },
      onProgress: function (progressData) {
        console.log(progressData, { percent: Math.floor(progressData.percent) })
      },
      onFileFinish: function (err, data, options) {   /* 非必须 */
        if (err) {
          params.onError(err)
        } else {
          params.onSuccess({ ...options, data, params })
        }
        TaskMap.delete(params.file)
      },
    }, function (err, data) {
      console.log(err || data);
    })
  })

}

export function reportUpload(params) {
  let credentials = {}
  let rpCos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function (options, callback) {
      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        SecurityToken: credentials.sessionToken,
        StartTime: credentials.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: credentials.expiredTime, // 时间戳，单位秒，如：1580000000
      });
    }
  });
  if (params.file.size > 1024 * 1024 * 2) {
    return params.onError(new Error("图片文件过大，请重新选择。"));
  }
  reportUploadImage().then(response => {
    try {
      var data = response.data;
      credentials = Object.assign({
        startTime: data.startTime,
        expiredTime: data.expiredTime,
      }, data.credentials);
    } catch (e) {
    }
    if (!data || !credentials) {
      return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
    };
    const uploadTarget = {
      ...data.extra
    }
    // console.log('uploadSeed', response)
    rpCos.uploadFile({
      ...data.extra,
      Body: params.file,
      SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onTaskReady: function (taskId) {                   /* 非必须 */
        console.log(taskId);
        TaskMap.set(params.file, taskId)
      },
      onProgress: function (progressData) {
        console.log(progressData, { percent: Math.floor(progressData.percent) })
      },
      onFileFinish: function (err, data, options) {   /* 非必须 */
        if (err) {
          params.onError(err)
        } else {
          rpCos.getObjectUrl({
            ...uploadTarget,
            Sign: true,
            Expires: 3600, // 单位秒
          }, function(err, data) {
            if (err) {
              params.onError(err)
            } else {
              const { Url } = data;
              params.onSuccess({ ...options, data, params, objectUrl: Url })
            }
          })
        }
        TaskMap.delete(params.file)
      },
    }, function (err, data) {
      console.log(err || data);
    })
  })
}

